import { combineReducers } from 'redux'
// ______________________________________________________
//
import * as auth from './auth'
import * as loading from './loading'
import * as dialog from './dialog'
import * as searchQuery from './searchQuery'
import * as searchQueryMessages from './searchQueryMessages'

export function initialState() {
  return {
    auth: auth.initialState(),
    loading: loading.initialState(),
    dialog: dialog.initialState(),
    searchQuery: searchQuery.initialState(),
    searchQueryMessages: searchQueryMessages.initialState()
  }
}
export const rootReducer = combineReducers({
  auth: auth.reducer,
  loading: loading.reducer,
  dialog: dialog.reducer,
  searchQuery: searchQuery.reducer,
  searchQueryMessages: searchQueryMessages.reducer
})
